<template>
  <div style="padding: 1vw">
      <div class="container-wrapper">
        <div class="page-title-container">
          <div class="page-title">
            <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
              환자 정보 조회
            </h3>
            <span class="pageDesc">
              병원에 등록된 환자의 정보를 조회할 수 있습니다.
            </span>
          </div>
          <div style="display: flex; align-items: center;">
          </div>
        </div>
      </div>
      <div class="container-wrapper">
        <div class="customerInfoBox col-sm-12">
          <div class="infoBox">
            <div class="icon-div" style="background-color: #D6DDFF">
              <i class="fa-solid fa-user" style="color: #788CED" />
            </div>
            <div class="info-div">
              <div class="multi-line">
                <span>전체 인증서</span>
                <span>수신 환자 수</span>
              </div>
              <h5>{{ formatCommaNumber(totalCustomers) }}<span>명</span></h5>
            </div>
            <div 
              style="
                cursor: pointer; 
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 0px;
                right: 0px;
                width: 30px;
                height: 30px;
              ;"
            >
              <n-tooltip trigger="hover">
                <template #trigger>
                  <i class="fa-regular fa-circle-question" style="margin: 0; color: #8D939A;"/>
                </template>
                삭제된 환자 수를 포함한 인증서 수신 환자 수입니다.
              </n-tooltip>
            </div>
          </div>
          <div class="infoBox">
            <div class="icon-div" style="background-color: #cdf4cd">
              <i class="fa-regular fa-wallet" style="color: #1FAD1F" />
            </div>
            <div class="info-div">
              <div class="multi-line">
                <span>지갑에 저장한</span>
                <span>수신자 수</span>
              </div>
              <h5>{{ formatCommaNumber(walletCustomers) }}<span>명</span></h5>
            </div>
          </div>
          <div class="infoBox">
            <div class="icon-div" style="background-color: #fff1b8">
              <svg 
                style="color: rgb(245, 155, 0)"
                xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"
              >
                <path d="M9.0025 1.125C4.03112 1.125 0 4.25326 0 8.10611C0 10.5048 1.56043 12.6186 3.93109 13.8779L2.93081 17.5409C2.84079 17.8657 3.21089 18.1255 3.49597 17.9356L7.87219 15.0323C8.24229 15.0672 8.61739 15.0872 8.9975 15.0872C13.9689 15.0872 18 11.959 18 8.10611C18 4.25326 13.9739 1.125 9.0025 1.125Z" fill="#F59B00"/>
              </svg>
            </div>
            <div class="info-div">
              <div class="multi-line">
                <span>카카오톡 인증서</span>
                <span>수신자 수</span>
              </div>
              <h5>{{ formatCommaNumber(kakaoReceivedCustomers) }}<span>명</span></h5>
            </div>
          </div>
          <div class="infoBox">
            <div class="icon-div" style="background-color: #E1F0FF">
              <i
                class="fa-regular fa-envelope"
                style="color: #278AEC; font-size: 18px"
              />
            </div>
            <div class="info-div">
              <div class="multi-line">
                <span>문자 인증서</span>
                <span>수신자 수</span>
              </div>
              <h5>{{ formatCommaNumber(lmsReceivedCustomers) }}<span>명</span></h5>
            </div>
          </div>
          <div class="infoBox">
            <div class="icon-div" style="background-color: #E8EBED">
              <i
                class="fa-solid fa-triangle-exclamation"
                style="color: #ACB2B9"
              />
            </div>
            <div class="info-div">
              <div class="multi-line">
                <span>인증서</span>
                <span>발송 실패 수</span>
              </div>
              <h5>{{ formatCommaNumber(notReceivedCustomers) }}<span>명</span></h5>
            </div>
          </div>
        </div>
      </div>
      <div class="container-wrapper">
        <div class="search-filter-container table-info-filter">
          <div class="search-filter-row">
            <div class="search-filter-title">
              검색어
            </div>
            <div class="search-filter-content">
              <select class="search-select" v-model="searchFilter.filter">
                <option value="">전체</option>
                <option value="name">환자명</option>
                <option value="mobile">전화번호</option>
                <option value="hospitalName">병원명</option>
              </select>
              <div class="search-input-container">
                <div class="search-icon">
                  <i
                    class="fa-regular fa-magnifying-glass"
                  />
                </div>
                <input 
                  type="text"
                  class="search-input-text"
                  v-model="searchFilter.keyword"
                  @keyup.enter="search"
                  placeholder="검색어를 입력하세요"
                />
              </div>
              <button
                class="search-btn"
                @click="search"
              >
                검색
              </button>
              <button
                class="init-btn"
                @click="initFilter"
              >
                초기화
              </button>
            </div>
          </div>
          <div class="search-filter-row">
            <div class="search-filter-title">
              조회 기간
            </div>
            <div class="search-filter-content">
              <!-- v1 -->
              <!-- <div class="date-selector-container custom">
                <n-date-picker 
                  v-model:value="searchFilter.startAt" 
                  type="date" 
                  placeholder="시작 날짜를 선택해 주세요."
                  :on-update:value="handleStartAt"
                />
                <div>~</div>
                <n-date-picker 
                  v-model:value="searchFilter.endAt" 
                  type="date"
                  placeholder="종료 날짜를 선택해 주세요."
                  :on-update:value="handleEndAt" 
                />
                <button
                  class="search-btn"
                  @click="searchAllPeriod"
                >
                  전체 기간 조회
                </button>
                <div class="filter-desc">(발행 시각 기준)</div>
              </div> -->
    
              <!-- v1 backup -->
              <div class="date-filter-container">
                <div
                  class="date-filter-item"
                  :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                  @click="handleDateFilter('all')"
                >
                  전체
                </div>
                <div 
                  v-for="item in searchFilter.dateFilters" 
                  class="date-filter-item"
                  :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"  
                  @click="handleDateFilter(item)"
                >
                  {{ item === 'etc' ? '기간 설정' : `최근 ${convertMonthAndYearText(item)}` }}
                </div>
              </div>
              <div class="date-selector-container custom" v-if="searchFilter.selectedDateFilter === 'etc'">
                <n-date-picker 
                  v-model:value="searchFilter.startAt" 
                  type="date" 
                  placeholder="시작 날짜를 선택해 주세요."
                  :on-update:value="handleStartAt"
                />
                <div>~</div>
                <n-date-picker 
                v-model:value="searchFilter.endAt" 
                type="date" 
                placeholder="종료 날짜를 선택해 주세요."
                :on-update:value="handleEndAt"
                />
                <!-- <button
                  class="search-btn"
                  @click="searchAllPeriod"
                >
                  전체 기간 조회
                </button> -->
                <div class="filter-desc">(환자 등록일 기준)</div>
              </div>
    
              <!-- v2 -->
              <!-- <div class="date-filter-container">
                <div 
                  v-for="(item, index) in searchFilter.dateFilters" 
                  class="date-filter-item"
                  :class="searchFilter.selectedDateFilter === item.value ? 'selected' : ''"  
                  @click="handleDateFilter(index)"
                >
                  {{ item.title }}
                </div>
              </div>
              <div class="date-selector-container" v-if="searchFilter.selectedDateFilter !== 'etc'">
                <button class="prev-btn" @click="goPrevDate(searchFilter.selectedDateFilter)">
                  <i class="fa-regular fa-chevron-left"/>
                </button>
                <div class="selected-period" @click="goNextDate(searchFilter.selectedDateFilter)">2023년 12월</div>
                <button class="next-btn">
                  <i class="fa-regular fa-chevron-right"/>
                </button>
              </div>
              <div class="date-selector-container custom" v-else>
                <div class="custom-period-container start-at">
                  2023/01/01
                  <button 
                    class="calendar-btn"
                    @click="handleCustomDate('start')"
                  >
                    <i class="fa-regular fa-calendar"/>
                  </button>
                </div>
                <div>~</div>
                <div class="custom-period-container end-at">
                  2023/12/31
                  <button 
                    class="calendar-btn"
                    @click="handleCustomDate('end')"
                  >
                    <i class="fa-regular fa-calendar"/>
                  </button>
                </div>
              </div> -->
            </div>
          </div>
          <div class="search-filter-row">
            <div class="search-filter-title">
              지갑 연동 상태
            </div>
            <div class="search-filter-content">
              <select 
                class="warranty-status-select"
                v-model="searchFilter.isConnected"
                @change="search"
              >
                <option value="">전체</option>
                <option :value="YnEnum.Y">연동</option>
                <option :value="YnEnum.N">미연동</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="container-wrapper">
        <div class="col-xs-12 table-info-filter">
          <div class="total-div">
            <p>
              전체 <span>{{ formatCommaNumber(listSize) }}</span>명
            </p>
          </div>
          <div class="search-container">
            <select class="search-select" v-model="rowsPerPage" @change="search">
              <option :value="10">10개씩 보기</option>
              <option :value="20">20개씩 보기</option>
              <option :value="50">50개씩 보기</option>
            </select>
            <button 
              @click="downloadExcelList"
              type="button" 
              class="header-btn active btn-hover"
            >
              <i class="fa-solid fa-down-to-bracket"/>
              엑셀 다운로드
            </button>
          </div>
          
        </div>
      </div>
      <div class="container-wrapper">
        <a-table 
          class="ant-table-striped"
          size="small"
          v-if="responseData"
          :columns="columns"
          :data-source="responseData"
          :pagination="false"
          @resizeColumn="handleResizeColumn"
        >
          <template #emptyText>
            <div class="noResult">검색 결과가 없습니다.</div>
          </template>
        </a-table>
        <pagination 
          :page-info="paginationData"
          page-name="CustomerManage"
          @change-page="paginationHandler"
        />
      </div>
  </div>
  <div
    class="modal fade"
    id="customerModify"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="customerModifyLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="modal_header_flex">
            <h1 class="modal-title fs-5" id="staticBackdropLabel">
              환자 정보 수정하기
            </h1>
          </div>
        </div>
        <div class="modal-division"/>
        <div class="modal-body" style="padding-top: 1rem">

          <div class="modalDivWrap">
            <div class="modalInputDiv">
              <label for="">
                이름
                <span class="requiredSpan">*</span>
              </label>
              <input
                type="text"
                id="modifyName"
                v-model="customerModifyModalData.name"
                placeholder="이름을 입력하세요"
              />
            </div>
            <div class="modalInputDiv">
              <label>
                연락처
                <span class="requiredSpan">*</span>
              </label>
              <input
                type="text"
                id="modifyMobile"
                v-model="customerModifyModalData.mobile"
                placeholder="010-0000-0000"
                maxlength="13"
                @input="onPhoneNumberChange()"
              />
            </div>
            <div class="modalInputDiv">
              <label>생년월일</label>
              <input
                type="text"
                id="modifyBirth"
                maxlength="10"
                @input="formatBirthday($event)"
                placeholder="YYYY/MM/DD"
                :value="customerModifyModalData.birth"
              />
            </div>
            <div class="modalInputDiv">
              <label>성별</label>
              <div class="radioWrap">
                <div class="radioObj">
                  <input 
                    type="radio" 
                    :value="GenderEnum.MALE"
                    :id="`customerGender${GenderEnum.MALE}`"
                    v-model="customerModifyModalData.gender"
                  /> 
                  <label :for="`customerGender${GenderEnum.MALE}`">남</label>
                </div>
                <div class="radioObj">
                  <input 
                    type="radio" 
                    :value="GenderEnum.FEMALE"
                    :id="`customerGender${GenderEnum.FEMALE}`"
                    v-model="customerModifyModalData.gender"
                  /> 
                  <label :for="`customerGender${GenderEnum.FEMALE}`">여</label>
                </div>
                <div class="radioObj">
                  <input 
                    type="radio" 
                    :value="''"
                    :id="`customerGenderNone`"
                    v-model="customerModifyModalData.gender"
                  /> 
                  <label :for="`customerGenderNone`">입력 안 함</label>
                </div>
              </div>
            </div>
            <div class="modalInputDiv">
              <label>지갑주소</label>
              <input
                type="text"
                style="background-color: rgb(243, 245, 246)"
                v-model="customerModifyModalData.klipAddress"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="modal-footer" 
        style="
        justify-content: center;

        ">
          <div style="display: flex; justify-content: space-between; width: 60%;">
            <button
              type="button"
              class="btn delete-btn"
              @click="deleteCustomer"
            >
              <span class="delete-btn-content">
                <i class="fa-solid fa-trash-can"/>
                삭제
              </span>
            </button>
            <div style="display: flex; gap: 16px;">
              <button
                type="button"
                class="btn btn-secondary cancel-btn"
                data-bs-dismiss="modal"
              >
                취소
              </button>
              <button
                type="button"
                class="btn btn-primary ok-btn"
                @click="updateCustomerInfo"
              >
                수정 완료
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <customer-detail-modal ref="DetailDiv" />
  
</template>
<script>
import {
  oneBtnDialog,
  twoBtnHtmlDialog,
  phoneNumberFormatter,
  convertDate,
  formatInputToDate,
  jwtDecoder,
  convertMonthAndYearText,
  convertDeptText,
  formatCommaNumber,
  removeHyphen,
} from '@/utils/utils';
import { 
  WarrantyStatusEnum,
  MedicalDept,
  GenderEnum, 
  YnEnum,
} from "@/enums/common.enums";
// import CustomerDetailModal from '@/views/History/components/CustomerDetailModal';
import GenderSelect from '@/views/History/components/GenderSelect';
import Pagination from '@/views/components/Pagination.vue';
import axios from 'axios';
import CustomerDetailModal from '@/views/History/components/CustomerDetailModal';

export default {
  name: 'CustomerList',
  components: { 
    CustomerDetailModal,
    GenderSelect,
    Pagination,
   },
   computed: {
    computedNoResultMessage() {
      if(this.calledApiTimes <= 1) {
        return '아직 등록된 환자가 없습니다.';
      } else {
        return '검색 결과가 없습니다.';
      }
    },
   },
  data() {
    return {
      formatCommaNumber,
      YnEnum,
      WarrantyStatusEnum,
      convertMonthAndYearText,

      isInputFocused: false,
      //모달 데이터
      customerModifyModalData: {},
      // 목록 받아오는 변수
      responseData: [],
      totalCustomers: 0,
      walletCustomers: 0,
      kakaoReceivedCustomers: 0,
      lmsReceivedCustomers: 0,
      notReceivedCustomers: 0,
      calledApiTimes: 0,

      detailCustomerId: '',
      detailNftid: '',
      isClicked: false, // CSS
      isOpen: false, // CSS
      medicalDept: [],
      GenderEnum,

      searchFilter: {
        filter: '',
        keyword: '',
        isConnected: '',
        // startAt: this.getPastDatesInUnixTime(3),
        // endAt: this.getCurrentUnixTime(),
        // selectedDateFilter: 3,
        // dateFilters: [3, 12, 36, 'etc']
        startAt: null,
        endAt: null,
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 36, 'etc']
      },

      // 페이지네이션 관련 변수
      listSize: 0,
      rowsPerPage: 10, 
      paginationData: {
        currentPage: 1, 
        totalPages: 0,
      },
      columns: [
        {key: 'index', title: '번호', dataIndex: 'index', align: 'center',  },
        {key: 'hospital', title: '이름', dataIndex: 'name', align: 'center',  },
        {key: 'companyMetadatas', title: '등록된 병원', dataIndex: 'companyMetadatas', align: 'center',  
          customRender: ({record}) => {
            if(Array.isArray(record.companyMetadatas)) {
              return <div>
              {record.companyMetadatas?.map((item, index) => (
                <div key={index}>{item.name}</div>
              ))}
              </div>
            } else {
              return <div/>
            }
                        
          }
        },
        {key: 'mobile', title: '연락처', dataIndex: 'mobile', align: 'center',  
          customRender: ({record}) => {
              return this.phoneNumberFormatter(record.mobile)
            }
        },
        {key: 'gender', title: '성별', dataIndex: 'gender', align: 'center',  
          customRender: ({record}) => {
            return this.convertGender(record.gender)
          }
        },
        {key: 'birth', title: '생년월일', dataIndex: 'birth', align: 'center',  
          customRender: ({record}) => {
            return this.convertDate(record.birth)
          }
        },
        {key: 'issueStatus', title: '지갑 연동 상태', dataIndex: 'issueStatus', align: 'center',  
          customRender: ({record}) => {
            return <div>
              {
                record.issueStatus && (
                  <div class="status-chip-wrap">
                    <div 
                      class={['status-chip', this.convertWarrantyStatusClass(record.issueStatus)]}
                    >
                      { this.convertWarrantyStatusMessage(record.issueStatus) }
                    </div>
                  </div>
                )
              }
              </div>
          }
        },
        {key: 'warrantyCount', title: '인증서 개수', dataIndex: 'warrantyCount', align: 'center', },
        {key: 'lastIssueAt', title: '최근 발행일', dataIndex: 'lastIssueAt', align: 'center',  
          customRender: ({record}) => {
            return this.convertDate(record.lastIssueAt)
          }
        },
        {key: 'createAt', title: '환자 등록 일자', dataIndex: 'createAt', align: 'center',  
          customRender: ({record}) => {
            return this.convertDate(record.createAt)
          }
        },
      ],
    };
  },
  async mounted() {
    await this.getHospitalInfo();
    this.handleDateFilter(3);
    const obj = {};
    obj.page = this.paginationData.currentPage;
    this.paginationHandler(obj);
  },

  methods: {
    formatInputToDate,
    convertDate,
    phoneNumberFormatter,
    getDetailData(customerId) {
      this.$refs.DetailDiv.fetchData(customerId, this.medicalDept);
    },
    async getHospitalInfo() {
      this.medicalDept = this.$store.getters.getMedicalDept;
    },
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getCustomerList();
    },
    handleResizeColumn(w, col) {
      col.width = w;
    },
    // 인증서 목록 전체
    async getCustomerList() {
      const obj = {};
      obj.page = this.paginationData.currentPage;
      obj.limit = this.rowsPerPage;
      obj.search = this.searchFilter.filter;
      if(this.searchFilter.keyword) obj.condition = removeHyphen(this.searchFilter.keyword);
      obj.walletStatus = this.searchFilter.isConnected;
      if(this.searchFilter.startAt && this.searchFilter.startAt) {
        obj.startAt = this.unixTimeToYYYYMMDD(this.searchFilter.startAt);
        obj.endAt = this.unixTimeToYYYYMMDD(this.searchFilter.endAt);
      }
      try {
        this.$store.commit('setIsLoading', true);
        const response = await this.$apiInstance.post(`/customers/v2`, obj);
        // const response = await axios.post(`${process.env.VUE_APP_SERVERURL}/customers/v2`, obj, {
        // headers: {
        //   'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImN0ZGVudCIsInN1YiI6IjY0YzllNjNmODRmNTMyZDNjMDYzNjg2OCIsInJvbGUiOiJIT1NQSVRBTCIsImlhdCI6MTcwNTkwNzg1NSwiZXhwIjoxNzA4NDk5ODU1fQ.PvrTxQvy1PzpDd3JjQPV213ksoVnul3vUQRaqG8z0vw'
        // }
        // });
        if (response.status === 200 || response.status === 201) {
          this.calledApiTimes ++;
          this.responseData = response.data.docs;
          this.listSize = response.data.totalDocs;

          for (let i = 0; i < this.responseData.length; i++) {
            this.responseData[i].index =
              this.listSize - i - (this.paginationData.currentPage - 1) * this.rowsPerPage;
          }
          this.totalCustomers = response.data.totalCustomers;
          this.walletCustomers = response.data.totalWallet;
          this.kakaoReceivedCustomers = response.data.totalBiz;
          this.lmsReceivedCustomers = response.data.totalLms;
          this.notReceivedCustomers = response.data.totalError;
          
          this.paginationData.totalPages = response.data.totalPages;
          this.$store.commit('setIsLoading', false);
        }
      } catch (error) {
        console.log(error);
        this.$store.commit('setIsLoading', false);
        await oneBtnDialog(`인증서 목록 로드 실패`, `인증서 목록 로드에 실패했습니다.`, false);
      }
    },
    async downloadExcelList() {
      this.$store.commit('setIsLoading', true);
      const year = new Date().getFullYear();
      const month = String(new Date().getMonth() + 1).padStart(2, '0');
      const day = String(new Date().getDate()).padStart(2, '0');
      const formattedDate = `${year}${month}${day}`;
      try {
        
        const obj = {};
      obj.search = this.searchFilter.filter;
      obj.condition = this.searchFilter.keyword;
      if(this.searchFilter.startAt && this.searchFilter.startAt) {
        obj.startAt = this.unixTimeToYYYYMMDD(this.searchFilter.startAt);
        obj.endAt = this.unixTimeToYYYYMMDD(this.searchFilter.endAt);
      }
        const response = await this.$apiInstance.post(
            `/customers/excel/v2`,obj,
            {
              headers: {
                'Content-Type': 'application/json',
              },
              responseType: 'blob',
            }
        );

        if (response.status === 200 || response.status === 201) {
          const blob = new Blob([response.data], { type: 'application/octet-stream' });

          const url = URL.createObjectURL(blob);

          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = `환자목록_${formattedDate}.xlsx`;
          downloadLink.click();

          URL.revokeObjectURL(url);
        } else {
          // Handle the error case
        }
        this.$store.commit('setIsLoading', false);
        
      } catch (error) {
        this.$store.commit('setIsLoading', false);
        console.error('Error downloading Excel file:', error);
      }
    },
    showCustomerModifyModal(record) {
      this.customerModifyModalData.id = record._id;
      this.customerModifyModalData.name = record.name;
      this.customerModifyModalData.birth = record.birth;
      if(this.responseData[i].gender) {
        this.customerModifyModalData.gender = record.gender;
      } else {
        this.customerModifyModalData.gender = '';
      }
      this.customerModifyModalData.mobile = phoneNumberFormatter(record.toString());
      this.customerModifyModalData.klipAddress = record.klipAddress;
    },
    async updateCustomerInfo() {
      const name = this.customerModifyModalData.name;
      const mobile = this.customerModifyModalData.mobile;
      const birth = this.customerModifyModalData.birth;
      const gender = this.customerModifyModalData.gender;

      const obj = {};
      obj.name = name;
      obj.mobile = mobile;
      obj.birth = birth;
      obj.gender = gender;
      if(await this.validateData()) {
        try {
        const response = await this.$apiInstance.put(`/customers/${this.customerModifyModalData.id}`, obj);
        if (response.status === 200 || response.status === 201) {
          document.getElementById('customerModify').style.display = 'none';
          await oneBtnDialog('환자 정보 수정 완료', '환자 정보 수정이 완료되었습니다.', true);
        }
      } catch (error) {
        console.log(error);
        if(error.response.status === 400) {
          await oneBtnDialog('연락처 형식 오류', '연락처는 01x-xxx(x)-xxxx의 형식이어야 합니다.', false);
        } else {
          await oneBtnDialog('환자정보 수정 실패', '환자정보 수정에 실패했습니다.', false);
        }
      }
      }
    },
    async deleteCustomer() {
      try {
        const isConfirmed = await twoBtnHtmlDialog(
            '환자 삭제',
            `<p><span style="font-weight: 600;">${this.customerModifyModalData.name}</span> 님을 삭제하시겠습니까? <br/>
              삭제하더라도 환자에게 발행한 인증서 이력은 발행 내역 조회에 남아있습니다.</p>`,
            '삭제'
        );
        if (!isConfirmed) return;

        const response = await this.$apiInstance.delete(`/customers/${this.customerModifyModalData.id}`);
        if (response.status === 200 || response.status === 201) {
          document.getElementById('customerModify').style.display = 'none';
          await oneBtnDialog('환자 정보 삭제 완료', '환자 정보 삭제가 완료되었습니다.', true);
        }
      } catch(error) {
        console.log(error);
        await oneBtnDialog('환자정보 삭제 실패', '환자정보 삭제에 실패했습니다.', false);
      }
    },
  
    async validateData() {
      const name = document.getElementById('modifyName').value;
      const mobile = document.getElementById('modifyMobile').value;
      const birth = document.getElementById('modifyBirth').value;
      let isValid = true;
      
      if(!name) {
        isValid = false;
        await oneBtnDialog('환자명 미기입', '환자명을 입력해 주세요.', false);
      } else if(!mobile) {
        isValid = false;
        await oneBtnDialog('휴대폰 번호 미기입', '휴대폰 번호를 입력해 주세요.', false);
      } else if(!mobile.startsWith('01') || mobile.length < 12) {
        isValid = false;
        await oneBtnDialog('휴대폰 번호 오류', '휴대폰 번호를 올바르게 입력해 주세요.', false);
      } else if(birth && birth.length < 10) {
        isValid = false;
        await oneBtnDialog('생년월일 오류', '생년월일을 올바르게 입력해 주세요.', false);
      }
      return isValid;
    },
    formatBirthday(event) {
      this.customerModifyModalData.birth = formatInputToDate(event.target.value);
    },
    handleGenderChange(gender) {
      this.customerModifyModalData.gender = gender;
    },

    // 검색 및관련
    handleStartAt(value) {
      this.searchFilter.startAt = value;
      this.search();
    },
    handleEndAt(value) {
      this.searchFilter.endAt = value;
      this.search();
    },
    handleDateFilter(value) {
      if (!value) return;
      if (value === this.searchFilter.selectedDateFilter) return;
    
      this.searchFilter.selectedDateFilter = value;

      if (value === 'all') {
        this.searchFilter.startAt = null;
        this.searchFilter.endAt = null;
      } else {
        this.searchFilter.startAt = this.getPastDatesInUnixTime(value);
        this.searchFilter.endAt = this.getCurrentUnixTime();
      }
      this.search();
    },
    getPastDatesInUnixTime(value) {
      const now = new Date();
      const threeMonthsAgo = new Date(now.setMonth(now.getMonth() - 3));
      const twelveMonthsAgo = new Date(now.setMonth(now.getMonth() - 9)); 
      const thirtySixMonthsAgo = new Date(now.setMonth(now.getMonth() - 24)); 

      now.setMonth(now.getMonth() + 36);

      const nowUnix = Math.floor(now.getTime());
      const threeMonthsAgoUnix = Math.floor(threeMonthsAgo.getTime());
      const twelveMonthsAgoUnix = Math.floor(twelveMonthsAgo.getTime());
      const thirtySixMonthsAgoUnix = Math.floor(thirtySixMonthsAgo.getTime());

      switch(value) {
        case 3:
          return threeMonthsAgoUnix;
        case 12: 
          return twelveMonthsAgoUnix;
        case 36: 
          return thirtySixMonthsAgoUnix;
        default: 
          return nowUnix;
      }
    },
    async search() {
      if(!await this.validateSearchFilter()) return;
      this.paginationData.currentPage = 1;
      await this.getCustomerList();
    },
    async searchAllPeriod() {
      this.searchFilter.startAt = null;
      this.searchFilter.endAt = this.getCurrentUnixTime();
      await this.getCustomerList();
    },
    async initFilter() {
      this.searchFilter = {
        filter: '',
        keyword: '',
        isConnected: '',
        startAt: null,
        endAt: null,
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 36, 'etc']
      }
      this.handleDateFilter(3);
    },
    getCurrentUnixTime() {
        const now = new Date();
        return Math.floor(now.getTime());
    },
    unixTimeToYYYYMMDD(unixTime) {
        // Create a new Date object from the Unix timestamp
        // Remember to multiply by 1000 because JavaScript expects milliseconds
        const date = new Date(unixTime);

        // Extract the year, month, and day as individual components
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // +1 because getMonth() returns 0-11
        const day = date.getDate().toString().padStart(2, '0');
        // Combine components into YYYYMMDD format
        return `${year}${month}${day}`;
    },
    async validateSearchFilter() {
      // 필터 걸어놓고 검색을 안함
      // 시작날짜가 과거날짜보다 큼
      if(this.searchFilter.startAt && !this.searchFilter.endAt) {
        return false;
      }
      if(this.searchFilter.startAt > this.searchFilter.endAt) {
        await oneBtnDialog('날짜 오류', '검색 시작일은 종료일보다 작아야 합니다.');
        return false;
      }
      return true;
    },
    convertWarrantyStatusMessage(input) {
      switch(input) {
        case WarrantyStatusEnum.ISSUED:
        return '지갑 저장됨';
        case WarrantyStatusEnum.DISPOSED:
        return '삭제됨';
        case WarrantyStatusEnum.RETURNED:
        return '회수됨';
        case WarrantyStatusEnum.BIZ_SEND_ERROR:
        return '발송 실패';
        case WarrantyStatusEnum.SEND_LMS:
        return '문자 전송됨';
        case WarrantyStatusEnum.SEND_BIZ:
        return '카톡 전송됨';
        case WarrantyStatusEnum.WECHAT_ISSUED:
        return '위챗 전송됨';
        default:
        return '-';
      }
    },
    convertWarrantyStatusClass(input) {
      switch(input) {
        case WarrantyStatusEnum.ISSUED:
        return WarrantyStatusEnum.ISSUED;
        case WarrantyStatusEnum.DISPOSED:
        return WarrantyStatusEnum.DISPOSED;
        case WarrantyStatusEnum.RETURNED:
        return WarrantyStatusEnum.RETURNED;
        case WarrantyStatusEnum.BIZ_SEND_ERROR:
        return WarrantyStatusEnum.BIZ_SEND_ERROR;
        case WarrantyStatusEnum.SEND_LMS:
        return WarrantyStatusEnum.SEND_LMS;
        case WarrantyStatusEnum.SEND_BIZ:
        return WarrantyStatusEnum.SEND_BIZ;
        case WarrantyStatusEnum.WECHAT_ISSUED:
        return WarrantyStatusEnum.WECHAT_ISSUED;
        default:
        return '';
      }
    },
    // 폰넘버 양식
    onPhoneNumberChange() {
      this.customerModifyModalData.mobile = phoneNumberFormatter(
        this.customerModifyModalData.mobile.toString()
      );
    },
    convertGender(input) {
      switch(input) {
        case 'M':
          return '남';
        case 'F':
          return '여';
        default: 
          return '-';
      }
    },
    phoneNumberFormatter,
  },
};
</script>
<style lang="scss" scoped>
  @import '@/assets/scss/certificates.scss';
</style>